import { reduce, find, findIndex, orderBy } from 'lodash';

import {
  TEAMS_FETCH_ALL_TEAMS,
  TEAMS_CREATE_TEAM,
  TEAMS_UPDATE_TEAM,
  TEAMS_DELETE_TEAM,
  TEAMS_VIEW_TEAM,
  TEAMS_FETCH_ALL_MEMBERS,
  TEAMS_FETCH_TEAM_TREE,
} from './TeamActions';

// Initial State
const initialState = {
  teams: {
    teams: [],
    owners: {},
    status: null,
    errors: null,
  },
  tree: {
    teams: [],
    owners: {},
    status: null,
    errors: null,
  },
  members: {
    owners: {},
    status: null,
    errors: null,
  },
};

const calibrateTeams = (teams, newTeam) => {
  if (newTeam.is_default) {
    const newTeams = reduce(teams, (items, team) => {
      if (team._id !== newTeam._id) {
        items.push({
          ...team,
          is_default: false,
        });
      } else {
        items.push(team);
      }
      return items;
    }, []);
    return orderBy(newTeams, { is_default: -1 });
  }
  return teams;
}

const TeamsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TEAMS_FETCH_ALL_TEAMS: {
      const {
        teams, owners, status, errors,
      } = action;
      const currentOwners = state.teams.owners;
      const newOwners = {
        ...currentOwners,
        ...owners,
      };
      return {
        ...state,
        teams: {
          teams,
          owners: newOwners,
          status,
          errors,
        },
      };
    }
    case TEAMS_CREATE_TEAM: {
      const { team } = action;
      const { teams: { teams } } = state;
      const newTeams = [...teams];
      newTeams.push(team);
      return {
        ...state,
        teams: {
          ...state.teams,
          teams: calibrateTeams(newTeams, team),
        },
      };
    }
    case TEAMS_UPDATE_TEAM: {
      const { team } = action;
      const { teams: { teams } } = state;
      let newTeams = teams;
      const idx = findIndex(teams, { _id: team._id });
      if (idx >= 0) {
        newTeams = [...teams];
        newTeams[idx] = team;
      }
      return {
        ...state,
        teams: {
          ...state.teams,
          teams: calibrateTeams(newTeams, team),
        },
      };
    }
    case TEAMS_DELETE_TEAM: {
      const { id } = action;
      const { teams: { teams } } = state;
      const newTeams = reduce(teams, (items, team) => {
        if (team._id !== id) {
          items.push(team);
        }
        return items;
      }, []);
      return {
        ...state,
        teams: {
          ...state.teams,
          teams: newTeams,
        },
      };
    }
    case TEAMS_VIEW_TEAM: {
      const { team, owners } = action;
      const currentTeams = state.teams.teams;
      const currentOwners = state.teams.owners;
      const newTeams = [...currentTeams];
      const idx = findIndex(newTeams, { _id: team._id });
      if (idx >= 0) {
        newTeams[idx] = team;
      } else {
        newTeams.push(team);
      }
      const newOwners = {
        ...currentOwners,
        ...owners,
      };
      return {
        ...state,
        teams: {
          ...state.teams,
          teams: newTeams,
          owners: newOwners,
        },
      };
    }
    case TEAMS_FETCH_ALL_MEMBERS: {
      const {
        owners, status, errors,
      } = action;
      return {
        ...state,
        members: {
          status,
          errors,
          owners,
        },
      };
    }
    case TEAMS_FETCH_TEAM_TREE: {
      const {
        teams, owners, status, errors,
      } = action;
      const currentOwners = state.tree.owners;
      const newOwners = {
        ...currentOwners,
        ...owners,
      };
      return {
        ...state,
        tree: {
          teams,
          owners: newOwners,
          status,
          errors,
        },
        members: {
          status: null,
          errors: null,
          owners: {},
        },
      };
    }
    default:
      return state;
  }
};


export const getAllTeams = state => state.teams.teams.teams;
export const getAllTeamOwners = state => state.teams.teams.owners;
export const getAllTeamsLoading = state => state.teams.teams.status === 'loading';
export const getAllTeamsLoaded = state => state.teams.teams.status === 'loaded';
export const getAllTeamsHasErrors = state => state.teams.teams.status === 'error';
export const getAllTeamsErrors = (state) => {
  if (state.teams.teams.status === 'error') {
    return state.teams.teams.errors;
  }
  return null;
};
export const getTeam = (state, id) => {
  const { teams } = state.teams.teams;
  return find(teams, { _id: id });
};

export const getAllMembers = state => state.teams.members.owners;
export const getAllMembersLoading = state => state.teams.members.status === 'loading';
export const getAllMembersLoaded = state => state.teams.members.status === 'loaded';
export const getAllMembersHasErrors = state => state.teams.members.status === 'error';
export const getAllMembersErrors = (state) => {
  if (state.teams.members.status === 'error') {
    return state.teams.members.errors;
  }
  return null;
};


export const getTeamTree = state => state.teams.tree.teams;
export const getTeamTreeOwners = state => state.teams.tree.owners;
export const getTeamTreeLoading = state => state.teams.tree.status === 'loading';
export const getTeamTreeLoaded = state => state.teams.tree.status === 'loaded';
export const getTeamTreeHasErrors = state => state.teams.tree.status === 'error';
export const getTeamTreeErrors = (state) => {
  if (state.teams.tree.status === 'error') {
    return state.teams.tree.errors;
  }
  return null;
};

// Export Reducer
export default TeamsReducer;
